const triggers = document.querySelectorAll(".btn-abo-tooltip");

if (triggers.length) {
    triggers.forEach(trigger => {
        const tooltipId = trigger.getAttribute("aria-describedby");
        const tooltip = document.getElementById(tooltipId);

        function showTooltip() {
            tooltip.style.opacity = "1";
            tooltip.style.visibility = "visible";
            trigger.setAttribute("aria-expanded", "true");
        }

        function hideTooltip() {
            tooltip.style.opacity = "0";
            tooltip.style.visibility = "hidden";
            trigger.setAttribute("aria-expanded", "false");
        }

        trigger.addEventListener("focus", showTooltip);
        trigger.addEventListener("blur", hideTooltip);
        trigger.addEventListener("mouseenter", showTooltip);
        trigger.addEventListener("mouseleave", hideTooltip);

        trigger.addEventListener("keydown", e => {
            if (e.key === "Escape") {
                hideTooltip();
                trigger.blur();
            }
        });
    });
}